export const subsidiaryConfig = [
  {
    id: '01',
    plz: '40210',
    displayName: 'Nordrhein-Westfalen',
    key: 'NW',
    sendEmptyTicket: false,
    couponAmounts: { 1: 9, 3: 5, 4: 12 },
  },
  {
    id: '02',
    plz: '80333',
    displayName: 'Bayern',
    key: 'BY',
    sendEmptyTicket: false,
    couponAmounts: { 1: 12, 3: 6, 4: 15 },
  },
  {
    id: '03',
    plz: '70173',
    displayName: 'Baden-Württemberg',
    key: 'BW',
    sendEmptyTicket: true,
    couponAmounts: { 1: 10, 3: 6, 4: 14 },
  },
  {
    id: '04',
    plz: '30159',
    displayName: 'Niedersachsen',
    key: 'NI',
    sendEmptyTicket: true,
    couponAmounts: { 1: 16, 3: 5, 4: 16 },
  },
  {
    id: '05',
    plz: '65189',
    displayName: 'Hessen',
    key: 'HE',
    sendEmptyTicket: false,
    couponAmounts: { 1: 14, 3: 7, 4: 18 },
  },
  {
    id: '06',
    plz: '55116',
    displayName: 'Rheinland-Pfalz',
    key: 'RP',
    sendEmptyTicket: false,
    couponAmounts: { 1: 14, 3: 5, 4: 16 },
  },
  {
    id: '07',
    plz: '10115',
    displayName: 'Berlin',
    key: 'BE',
    sendEmptyTicket: false,
    couponAmounts: { 1: 20, 3: 5, 4: 20 },
  },
  {
    id: '08',
    plz: '24103',
    displayName: 'Schleswig-Holstein',
    key: 'SH',
    sendEmptyTicket: false,
    couponAmounts: { 1: 20, 3: 5, 4: 20 },
  },
  {
    id: '09',
    plz: '20095',
    displayName: 'Hamburg',
    key: 'HH',
    sendEmptyTicket: false,
    couponAmounts: { 1: 12, 3: 5, 4: 16 },
  },
  {
    id: '10',
    plz: '01067',
    displayName: 'Sachsen',
    key: 'SN',
    sendEmptyTicket: false,
    couponAmounts: { 1: 18, 3: 5, 4: 18 },
  },
  {
    id: '11',
    plz: '39106',
    displayName: 'Sachsen-Anhalt',
    key: 'ST',
    sendEmptyTicket: false,
    couponAmounts: { 1: 14, 3: 5, 4: 16 },
  },
  {
    id: '12',
    plz: '66117',
    displayName: 'Saarland',
    key: 'SL',
    sendEmptyTicket: false,
    couponAmounts: { 1: 20, 3: 5, 4: 20 },
  },
  {
    id: '13',
    plz: '14467',
    displayName: 'Brandenburg',
    key: 'BB',
    sendEmptyTicket: true,
    couponAmounts: { 1: 15, 3: 6, 4: 18 },
  },
  {
    id: '14',
    plz: '99084',
    displayName: 'Thüringen',
    key: 'TH',
    sendEmptyTicket: false,
    couponAmounts: { 1: 9, 3: 5, 4: 14 },
  },
  {
    id: '15',
    plz: '28195',
    displayName: 'Bremen',
    key: 'HB',
    sendEmptyTicket: false,
    couponAmounts: { 1: 20, 3: 5, 4: 20 },
  },
  {
    id: '16',
    plz: '17214',
    displayName: 'Mecklenburg-Vorpommern',
    key: 'MV',
    sendEmptyTicket: false,
    couponAmounts: { 1: 20, 3: 5, 4: 20 },
  },
];

export const getSubsidiaryMailFromId = (id) => {
  return id ? `${id}@lotto.de` : '';
};
export const getSubsidiaryIdFromMail = (mail: string) => {
  return mail.match(/^([0-9]{2})@lotto.de$/) ? mail.substring(0, 2) : '';
};
export const getSubsidiaryPlzFromMail = (mail: string) => {
  const id = getSubsidiaryIdFromMail(mail);
  if (id) {
    const result = findSubsidiaryById(id);
    if (!result) return;
    return result.plz;
  }
};

export const findSubsidiaryById = (subsidiary: string) => {
  const result = subsidiaryConfig.find((config) => config.id === subsidiary);
  if (!result) return;
  return result;
};
export const findSubsidiaryByPlz = (subsidiary: string) => {
  const result = subsidiaryConfig.find((config) => config.plz === subsidiary);
  if (!result) return;
  return result;
};
export const findSubsidiaryByKey = (subsidiary: string) => {
  const result = subsidiaryConfig.find((config) => config.key === subsidiary);
  if (!result) return;
  return result;
};
